import API from '../../../../network/dashboardAPI';

/**
 * Thin wrappers over the /api/wms/* endpoints.
 *
 * Every wrapper resolves to the parsed body and never throws, so callers can
 * branch on `success` / `error` instead of wrapping each call in try/catch.
 */

export const fetchWmsProducts = async (params = {}) => {
	try {
		const response = await API.getWmsProducts(params);
		return response.json();
	} catch (error) {
		console.error('Error fetching WMS products:', error);
		return {error: true, success: false, data: error.message || 'Failed to fetch products'};
	}
};

/**
 * Update one variant's weight.
 *
 * Always sends price_type_id (variant grain) rather than item_id, so the write
 * lands on exactly the row the user edited — item_id would fan the weight out
 * to every variant of the product.
 */
export const updateWmsWeight = async (price_type_id, weight) => {
	try {
		const response = await API.updateWmsProductWeight({price_type_id, weight});
		return response.json();
	} catch (error) {
		console.error('Error updating product weight:', error);
		return {error: true, success: false, data: error.message || 'Failed to update weight'};
	}
};

/**
 * Update every live variant of a product in one call.
 */
export const updateWmsWeightByItemId = async (item_id, weight) => {
	try {
		const response = await API.updateWmsProductWeight({item_id, weight});
		return response.json();
	} catch (error) {
		console.error('Error updating product weight:', error);
		return {error: true, success: false, data: error.message || 'Failed to update weight'};
	}
};

/**
 * Batch weight update.
 *
 * @param {Array} items - [{price_type_id, weight}] — weight in grams.
 * Note the endpoint answers 200 with partial failures collected in
 * `data.errors`, so a truthy `success` alone does not mean every row applied.
 */
export const bulkUpdateWmsWeights = async (items) => {
	try {
		const response = await API.bulkUpdateWmsProductWeights({items});
		return response.json();
	} catch (error) {
		console.error('Error bulk updating product weights:', error);
		return {error: true, success: false, data: error.message || 'Failed to bulk update weights'};
	}
};

export const updateWmsWeightBySku = async (product_code, weight) => {
	try {
		const response = await API.updateWmsProductWeightBySku({product_code, weight});
		return response.json();
	} catch (error) {
		console.error('Error updating product weight by SKU:', error);
		return {error: true, success: false, data: error.message || 'Failed to update weight'};
	}
};
